import React from 'react'
import styled from 'styled-components'

export const IonIcon = styled(props => (
  <ion-icon {...props} class={props.className} />
))`
  font-size: ${fontSize};
`

function fontSize({ size = 'md' }) {
  switch (size) {
    case 'md':
      return '16px'
    case 'lg':
      return '24px'
    case '2x-lg':
      return '36px'
    case '3x-lg':
      return '48px'
    default:
      return '16px'
  }
}



// WEBPACK FOOTER //
// ./src/components/views/ionicon/IonIcon.js